




















































import {
  computed,
  defineComponent, PropType, useCssModule,
} from '@nuxtjs/composition-api';
import colorsMapping from '../swatch-mapping.json';
import swatchBgMapping from '../swatch-bg-mapping.json';
import SvgImage from '~/components/General/SvgImage.vue';
import { removeObjectEmptyFields } from '~/helpers/removeObjectEmptyFields';
import { YieldsInterface } from '~/modules/GraphQL/types';

export default defineComponent({
  name: 'YieldsList',

  components: {
    SvgImage,
  },

  props: {
    yields: {
      type: [Array, null] as PropType<YieldsInterface[] | null>,
      default: () => [],
    },
    isMaintenance: {
      type: Boolean,
      default: false,
    },
    isListing: {
      type: Boolean,
      default: false,
    },
    propsStyles: {
      type: Object,
      default: null,
    },
  },

  setup(props) {
    const defaultStyles = useCssModule();
    const setYieldPropType = (yieldProp) => {
      const preparedYieldText = yieldProp?.yield_text.replace(",", "").trim().replace(/(.*)\s?[xX]\s?(\d+)/, '$1')
      yieldProp.type = preparedYieldText.replace(/^([\d\.\,]+)(.*)$/, '$2').trim()
      if (yieldProp?.type?.toLowerCase() === 'engineer required') {
        yieldProp.type = ''
      }

      yieldProp.yield = preparedYieldText.replace(/^([\d\.\,]+)(.*)$/, '$1').trim()
    }
    props.yields.forEach((yieldProp) => {
      const multiplicatorSearch = /(\d+)\s?[xX]/.exec(yieldProp.yield_text || '') || /[xX]\s?(\d+)/.exec(yieldProp.yield_text || '')
      yieldProp.multiplicator = multiplicatorSearch ? multiplicatorSearch[1] : 1
      yieldProp.midIndex = Math.ceil(yieldProp.swatches.length / 2)
      setYieldPropType(yieldProp)
    });
    const computedStyles = computed(() => ({ ...defaultStyles, ...removeObjectEmptyFields(props.propsStyles) }));
    const isPhotosYields = (yieldItem) => (yieldItem?.yield_text ? yieldItem.yield_text.indexOf('photos (') > 0 : false);
    const getYieldTextForMobile = (yieldText = '') => {
      const yieldTextType = yieldText.split(' ');

      if (yieldTextType?.[1] === 'pages') {
        return yieldTextType[0];
      }

      return yieldText;
    };
    return {
      computedStyles,
      colorsMapping,
      swatchBgMapping,
      isPhotosYields,
      getYieldTextForMobile,
    };
  },
});

